import { render, staticRenderFns } from "./D3KnowledgeGraph.vue?vue&type=template&id=35e884be&scoped=true&"
import script from "./D3KnowledgeGraph.vue?vue&type=script&lang=js&"
export * from "./D3KnowledgeGraph.vue?vue&type=script&lang=js&"
import style0 from "./D3KnowledgeGraph.vue?vue&type=style&index=0&id=35e884be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e884be",
  null
  
)

export default component.exports